/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Feed_Url_Hint_JobsInputs */

const cs_import_feed_url_hint_jobs = /** @type {(inputs: Import_Feed_Url_Hint_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložte GetJobStamps.php (všechny nabídky) nebo GetJob.php?export_id=… — profily makléřů načteme automaticky.`)
};

const en_import_feed_url_hint_jobs = /** @type {(inputs: Import_Feed_Url_Hint_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste GetJobStamps.php (all offers) or GetJob.php?export_id=… — we expand nested broker profiles automatically.`)
};

/**
* | output |
* | --- |
* | "Paste GetJobStamps.php (all offers) or GetJob.php?export_id=… — we expand nested broker profiles automatically." |
*
* @param {Import_Feed_Url_Hint_JobsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_feed_url_hint_jobs = /** @type {((inputs?: Import_Feed_Url_Hint_JobsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Feed_Url_Hint_JobsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_feed_url_hint_jobs(inputs)
	return cs_import_feed_url_hint_jobs(inputs)
});